import React, { useState, useEffect } from 'react';
import OTPInput from 'react-otp-input';
import { Button, Typography, Flex, message, Alert } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { requestOTP, verifyOTP } from '../../features/Login/UserSlice';
const { Title } = Typography;

const OTPVerification = () => {
    const dispatch = useDispatch();
    const navigate= useNavigate();
    const [otp, setOtp] = useState('');
    const [email, setEmail] = useState('');
    const [userId, setUserId] = useState('');
    const [searchParams] = useSearchParams();
    const [messageErr, setMessageErr] = useState('');

    useEffect(() => {
        const emailParam = searchParams.get('email');
        const userIdParam = searchParams.get('user_id');
        if (emailParam) setEmail(emailParam);
        if (userIdParam) setUserId(userIdParam);
    }, [searchParams]);

    const handleVerify = () => {
        const payload = {
            user_id: Number(userId),
            otp: Number(otp)
        }
        if (otp.trim() === '' || otp<99999) {
            return setMessageErr('Please enter the OTP!');
        }else{
            setMessageErr('');
            dispatch(verifyOTP(payload)).then((result) => {
                if (result?.error?.message == "Rejected") {
                    setMessageErr(result?.payload?.error || "Retry after some time!", 3);
                }else {
                    setMessageErr('');
                    message.success('OTP Verified Successfully!', 3);
                    navigate('/login');
                }
            })
        }
    };

    const handleResendOTP = () => {
        dispatch(requestOTP({ user_id: Number(userId), email: email })).then((result) => {
            // console.log(result?.error?.message == "Rejected")
            if (result?.error?.message == "Rejected") {
                setMessageErr('')
                message.error(result?.payload?.message || "Failed to resend OTP", 3);
            }else {
                setMessageErr('');
                message.success('OTP resent successfully!', 3);
            }
        })
    };

    return (
        <Flex gap="middle" align="flex-start" vertical>
            <Title level={5}>Enter OTP</Title>
            <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                    width: '100%',
                    height: '40px',
                    margin: '0 5px',
                    textAlign: 'center',
                    borderRadius: '4px',
                    border: '1px solid #d9d9d9',
                }}
            />
            {messageErr && <Alert message={messageErr} type="error" />}
            <Button type="primary" className="login-form-button" block onClick={handleVerify}>
                Verify
            </Button>

            <Button type="link" block onClick={() => handleResendOTP()}>
                Resend OTP
            </Button>
        </Flex>
    );
};

export default OTPVerification;
